<template>
	<q-modal
		v-model="show_portfolio_modal"
		:content-css="{ minWidth: '100vw', minHeight: '100vh' }"
		no-backdrop-dismiss
		no-esc-dismiss
	>
		<q-modal-layout>
			<q-toolbar slot="header">
				<q-btn flat round dense @click="show_portfolio_modal = false" icon="fas fa-times" />
				<q-toolbar-title>
					{{ $t('sort_portfolio') }}
				</q-toolbar-title>
			</q-toolbar>

			<div class="layout-padding">
				<q-list v-for="area in portfolio_areas" :key="area.id">
					<q-collapsible
						group="areas"
						icon="far fa-layer-group"
						class="text-bold"
						:label="area.name"
					>
						<draggable class="row" :list="area.group_trainings">
							<q-card
								inline
								style="width: 20%"
								class="q-pa-xs cursor-pointer col-xs-12 col-md-2 col-2"
								v-for="(gt, index) in area.group_trainings"
								:key="gt.id"
								@dragend.native="changeTrainingOrder"
							>
								<q-card-media overlay-position="top">
									<img :src="gt.image ? gt.image : getPlaceholder" />
									<q-card-title class="text-right" slot="overlay">
										<strong slot="subtitle" style="display:block">{{
											gt.title
										}}</strong>

										<span slot="subtitle">
											<q-icon
												class="q-mr-sm"
												name="far fa-layer-group"
												color="white"
												size="1rem"
											/>
											<strong style="font-size: 1rem">{{ index }}</strong>
										</span>
									</q-card-title>
								</q-card-media>
							</q-card>
						</draggable>
					</q-collapsible>
				</q-list>

				<div class="row gutter-sm justify-end q-mt-lg">
					<div class="col-xs-12 col-sm-3 order-last">
						<q-btn
							color="tertiary"
							class="full-width"
							:label="$t('back')"
							icon="far fa-chevron-left"
							@click="show_portfolio_modal = false"
						/>
					</div>
				</div>
			</div>
		</q-modal-layout>
	</q-modal>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'

export default {
	name: 'PortfolioOrderingModal',

	props: ['show_portfolio_ordering'],

	components: {
		draggable,
	},

	data() {
		return {
			group_trainings_porfolio_order: [],
			portfolio_areas: [],
			selected_client_params: [],
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		show_portfolio_modal: {
			get() {
				return this.show_portfolio_ordering
			},
			set() {
				this.$emit('hide_portfolio_modal', '')
			},
		},

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getPlaceholder() {
			if (!this.selected_client_params.group_training_placeholder) return ''
			else return this.selected_client_params.group_training_placeholder
		},
	},

	methods: {
		fetchPortfolioTrainings() {
			this.$q.loading.show()

			this.$axios
				.get(
					`/etraining_portfolio/group_trainings/${this.id_user_client_country_selected}/`
				)
				.then((response) => {
					this.portfolio_areas = response.data
						? response.data.map((a) => {
								return {
									...a,
									group_trainings: a.group_trainings
										.map((training, index) => {
											return {
												...training,
												index:
													training.portfolio_order &&
													training.portfolio_order !== 9999
														? training.portfolio_order
														: index,
											}
										})
										.sort((a, b) => a.portfolio_order - b.portfolio_order),
								}
						  })
						: []
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		saveTrainingsOrder() {
			this.$q.loading.show()

			const data = {
				group_trainings_portfolio_order: (this.group_trainings_porfolio_order = this.portfolio_areas.flatMap(
					(a) => {
						return a.group_trainings.map((training) => ({
							id: training.id,
							portfolio_order: training.portfolio_order,
						}))
					}
				)),
			}

			this.$axios
				.post(
					`/admin_group_trainings/group_trainings/change_group_trainings_order/`,
					data,
					this.getHeader
				)
				.then(() => {
					this.$q.notify({
						message: this.$t('saved_successfully'),
						type: 'positive',
						icon: 'fal fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
					this.$q.notify({
						message: this.$t('save_error'),
						type: 'negative',
						icon: 'fal fa-ban',
					})
				})
				.finally(() => {
					this.group_trainings_porfolio_order = []
					this.fetchPortfolioTrainings()
				})
		},

		changeTrainingOrder() {
			// if (this.dragstart_order === this.dragend_order) return this.clearDragIndexes()
			this.portfolio_areas = this.portfolio_areas.map((a) => {
				return {
					...a,
					group_trainings: a.group_trainings.map((training, updatedIndex) => {
						return { ...training, portfolio_order: updatedIndex }
					}),
				}
			})

			this.saveTrainingsOrder()
		},

		getClientParams() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			this.selected_client_params = client ? client : {}
		},
	},

	mounted() {
		this.fetchPortfolioTrainings()
		this.getClientParams()
	},
}
</script>

<style></style>
